import { render, staticRenderFns } from "./AAlertas.vue?vue&type=template&id=74267c8e"
import script from "./AAlertas.vue?vue&type=script&lang=js"
export * from "./AAlertas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports